import Spinner from "./Spinner";

export default function Loader({ loading, children, ...props }) {
  return (
    (loading && (
      <div
        className="row"
        style={{
          width: "100%",
          height: "80%",
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <div className="col-sm-offset-5 col-sm-3">
          <Spinner />
        </div>
      </div>
    )) || <>{children}</>
  );
}
